import { lazy, ComponentType } from 'react';

const RELOAD_KEY = 'chunk-reload-retry';

// `any` is justified: it mirrors React.lazy's own constraint
// (ComponentType<any>). FC's propTypes/defaultProps make ComponentType
// invariant in its type parameter, so neither `unknown` nor `never`
// accepts every page component — only `any` does.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) {
  return lazy(() =>
    importFn().catch((error: Error) => {
      const hasReloaded = sessionStorage.getItem(RELOAD_KEY);

      if (!hasReloaded) {
        sessionStorage.setItem(RELOAD_KEY, '1');
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }

      sessionStorage.removeItem(RELOAD_KEY);
      throw error;
    })
  );
}
